import Carousel from 'global/carousel.src';
import lottie from 'lottie-web';
import startFreeTrialForm from 'global/free-trial-form2.src';

(function ready(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(() => {
    [].forEach.call(document.querySelectorAll('.free-trial-form'), (form) => {
        startFreeTrialForm.init(form);
    });

    [].forEach.call(document.querySelectorAll('.carousel'), (item) => {
        const c = new Carousel(item);
    });

    /* ------------------------------------*\
		ANIMATE
  \*------------------------------------*/
    const res2dppx = window.matchMedia('(min-resolution: 2dppx)').matches;
    const isDesktop = window.matchMedia('(min-width: 600px)').matches;

    const lotties = JSON.parse(document.querySelector('#lotties').innerHTML);

    const animData = {
        hero: {
            container: document.getElementById('hero'),
            renderer: 'svg',
            loop: lotties.hero.loop,
            autoplay: true,
            path: lotties.hero[res2dppx ? '@2x' : '@1x'],
        },
        lottie1: {
            container: document.getElementById('lottie1'),
            renderer: 'svg',
            loop: lotties.lottie1.loop,
            autoplay: true,
            path: lotties.lottie1[res2dppx ? '@2x' : '@1x'],
        },
        lottie2: {
            container: document.getElementById('lottie2'),
            renderer: 'svg',
            loop: lotties.lottie2.loop,
            autoplay: true,
            path: lotties.lottie2[res2dppx ? '@2x' : '@1x'],
        },
        lottie3: {
            container: document.getElementById('lottie3'),
            renderer: 'svg',
            loop: lotties.lottie3.loop,
            autoplay: !isDesktop,
            path: lotties.lottie3[res2dppx ? '@2x' : '@1x'],
        },
        lottie4: {
            container: document.getElementById('lottie4'),
            renderer: 'svg',
            loop: lotties.lottie4.loop,
            autoplay: !isDesktop,
            path: lotties.lottie4[res2dppx ? '@2x' : '@1x'],
        },
        lottie5: {
            container: document.getElementById('lottie5'),
            renderer: 'svg',
            loop: lotties.lottie5.loop,
            autoplay: !isDesktop,
            path: lotties.lottie5[res2dppx ? '@2x' : '@1x'],
        },
        lottie6: {
            container: document.getElementById('lottie6'),
            renderer: 'svg',
            loop: lotties.lottie6.loop,
            autoplay: !isDesktop,
            path: lotties.lottie6[res2dppx ? '@2x' : '@1x'],
        },
        lottie7: {
            container: document.getElementById('lottie7'),
            renderer: 'svg',
            loop: lotties.lottie7.loop,
            autoplay: true,
            path: lotties.lottie7[res2dppx ? '@2x' : '@1x'],
        },
        lottie8: {
            container: document.getElementById('lottie8'),
            renderer: 'svg',
            loop: lotties.lottie8.loop,
            autoplay: true,
            path: lotties.lottie8[res2dppx ? '@2x' : '@1x'],
        },
    };

    const anim = {};
    anim.hero = lottie.loadAnimation(animData.hero);
    anim.lottie1 = lottie.loadAnimation(animData.lottie1);
    anim.lottie2 = lottie.loadAnimation(animData.lottie2);
    anim.lottie3 = lottie.loadAnimation(animData.lottie3);
    anim.lottie4 = lottie.loadAnimation(animData.lottie4);
    anim.lottie5 = lottie.loadAnimation(animData.lottie5);
    anim.lottie6 = lottie.loadAnimation(animData.lottie6);
    anim.lottie7 = lottie.loadAnimation(animData.lottie7);
    anim.lottie8 = lottie.loadAnimation(animData.lottie8);

    Object.keys(anim).forEach((a) => {
        anim[a].addEventListener('loaded_images', () => {
            anim[a].play();
        });
    });

    [].forEach.call(document.querySelectorAll('.tabbed-sections'), (tabbedSection) => {
        [].forEach.call(tabbedSection.querySelectorAll('h3 > a'), (el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();

                if (tabbedSection.querySelector(el.getAttribute('href')).classList.contains('current')) {
                    return;
                }

                tabbedSection.querySelector('h3.current').classList.remove('current');
                el.parentElement.classList.add('current');

                const currentSection = tabbedSection.querySelector('section.current');

                if (tabbedSection.querySelector('section.hide')) {
                    tabbedSection.querySelector('section.hide').classList.remove('hide');
                }
                if (tabbedSection.querySelector('section.show')) {
                    tabbedSection.querySelector('section.show').classList.remove('show');
                }
                currentSection.classList.remove('current');
                currentSection.classList.add('hide');

                tabbedSection.querySelector(el.getAttribute('href')).classList.add('show');
                tabbedSection.querySelector(el.getAttribute('href')).classList.add('current');

                [].forEach.call(tabbedSection.querySelectorAll('h3:not(.current) > a'), (a) => {
                    if (a.getAttribute('data-lottie')) {
                        anim[a.getAttribute('data-lottie')].stop();
                    }
                });
                if (el.getAttribute('data-lottie')) {
                    anim[el.getAttribute('data-lottie')].play();
                }
            });
        });
    });
});
